import React, { useEffect } from 'react';

const InstagramEmbed = ({ url }) => {
  useEffect(() => {
    if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
  }, []);
  

  return (
    <div className="w-full max-w-md mx-auto">
    <blockquote 
      className="instagram-media" 
      data-instgrm-permalink={url} 
      data-instgrm-version="14" 
      style={{ margin: "auto", maxWidth: "540px", width: "100%" }}
    ></blockquote>
  </div>
  );
};

export default InstagramEmbed;
